export const AgreementType = {
  Horizontal: "horizontal",
  Vertical: "vertical",
}
